// import React, { useEffect, useRef, useState } from "react";
// import { apiGet } from "../../api/api_methods"; // Adjust the path accordingly
// import JobCard from "./JobCard";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useStores } from "../../store";
// import ReactPaginate from "react-paginate";
// import Loader from "../reusble_components/loader";
// import image from "../../assests/office-building.png";
// import { useObserver } from "mobx-react";
// import CommonStore from "../../store/common_store";
// import { defaultProfilePic } from "../../helpers/constantVariables";
// import JobInternshipShimmer from "./components/JobInternshipShimmer";

// const JobList = ({ scrollRef }) => {
//   const { RecuiterStore } = useStores();
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   // const scrollRef = useRef(null);
//   // const [currentPage, setCurrentPage] = useState(RecuiterStore.jobListPage);
//   const jobsPerPage = 12;
//   const navigate = useNavigate();
//   const location = useLocation();
//   const query = new URLSearchParams(location.search);
//   const page = query.get("page") || 0;

//   const fetchJobs = async (currentPage = 0) => {
//     try {
//       setLoading(true);
//       // alert( "fetchJobs" );
//       const skip = currentPage * jobsPerPage;
//       const body = {
//         skip,
//         limit: jobsPerPage,
//       };
//       // if(RecuiterStore.jobPosts.length === 0){
//       await RecuiterStore.fetchJobPosts(body);
//       // }
//       if (RecuiterStore.jobApplications.length === 0) {
//         const bodyForApplications = {
//           skip: 0,
//           limit: jobsPerPage,
//         };
//         await RecuiterStore.fetchJobApplications(bodyForApplications);
//       }
//     } catch (err) {
//       setError("Failed to fetch job posts. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {

//     if (RecuiterStore.jobPosts.length === 0) {
//       fetchJobs(page);
//     }
//   }, []);

//   const handleApply = async (jobPostId) => {
//     const appliedApplication = RecuiterStore.jobApplications.find(
//       (application) => application.jobPostId._id === jobPostId
//     );

//     if (appliedApplication) {
//       navigate(`/dashboard/myapplicants/${appliedApplication._id}`);
//     } else {
//       navigate(`/dashboard/JobInternship/job-post/${jobPostId}`);
//     }
//   };

//   const handleApplyMobile = async (jobPostId) => {
//     const appliedApplication = RecuiterStore.jobApplications.find(
//       (application) => application.jobPostId._id === jobPostId
//     );

//     if (appliedApplication) {
//       navigate(`/newone/${appliedApplication._id}`);
//     } else {
//       navigate(`/jobpost/${jobPostId}`);
//     }
//   };

//   const hasApplied = (jobId) => {
//     return RecuiterStore.jobApplications.some(
//       (application) => application.jobPostId?._id === jobId
//     );
//   };

//   const handlePageClick = (event) => {
//     navigate("/dashboard/jobinternship?page=" + event.selected);
//     setLoading(true);
//     RecuiterStore.setJobListPage(event.selected);
//     fetchJobs(event.selected).then(() => {
//       setLoading(false);
//     });
//   };

//   // const renderPageNumbers = () => {
//   //   const pageNumbers = [];
//   //   for (let i = 1; i <= RecuiterStore.totalPage; i++) {
//   //     pageNumbers.push(
//   //       <button
//   //         key={i}
//   //         className={`mx-1 px-3 py-1 rounded ${
//   //           i === currentPage + 1 ? "bg-blue-500 text-white" : "bg-gray-200"
//   //         }`}
//   //         onClick={() => handlePageClick({ selected: i - 1 })}
//   //       >
//   //         {i}
//   //       </button>
//   //     );
//   //   }
//   //   return pageNumbers;
//   // };
//   const checkSalary = (salary) => {
//     if (salary === undefined || salary === null) {
//       return "N/A";
//     }
//     if (salary >= 100000) {
//       return `${salary / 100000}L`;
//     }
//     if (salary >= 1000) {
//       return `${salary / 1000}K`;
//     }

//     return salary;
//   };

//   return useObserver(() => {
//     if (error) return <div>{error}</div>;

//     return (
//       <>
//         {/* {loading && <Loader loader={true} />} */}
//         <div className="md:pb-0 lg:pb-0 pb-[13%]">
//           {loading ? (
//             <JobInternshipShimmer />
//           ) : (
//             <>
//             {RecuiterStore.jobPosts.length == 0 && (
//               <div  className="flex items-center justify-center w-full h-[80vh] ">
//                 <h1 className="text-primary text-3xl">Oops! No results found. Broaden your search criteria and try again.</h1>
//                 </div>
//             )}
//             <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
//               {RecuiterStore.jobPosts?.map((job, index) => {
//                 const applied = hasApplied(job?._id);
//                 const minSalary = checkSalary(job?.salary?.minimum);
//                 const maxSalary = checkSalary(job?.salary?.maximum);

//                 const salary = checkSalary(
//                   job?.salary?.exactAmount ?? job?.salary?.minimum
//                 );
//                 const formattedSalary =
//                   minSalary !== "N/A" && maxSalary !== "N/A"
//                     ? (job?.salary?.currency?.split(" ")[0] ?? "₹") +
//                       " " +
//                       `${minSalary} - ${maxSalary} ` +
//                       job?.salary?.rate.replace("per", "")
//                     : (job?.salary?.currency?.split(" ")[0] ?? "₹") +
//                       " " +
//                       salary +
//                       "/" +
//                       (job?.salary?.rate === "perYear"
//                         ? "Year"
//                         : job?.salary?.rate === "perMonth"
//                         ? "Month"
//                         : job?.salary?.rate === "perDay"
//                         ? "Day"
//                         : job?.salary?.rate === "perHour"
//                         ? "Hour"
//                         : "");
//                 return (
//                   <JobCard
//                     job={job}
//                     JobInternship={true}
//                     key={job?._id}
//                     logo={job?.recruiterId?.pic || image}
//                     featured={job?.featured || false}
//                     title={job?.jobTitle || "Job Title"}
//                     company={job?.recruiterId.name}
//                     postedTime={job?.createdAt}
//                     salaryRange={
//                       !job?.salary?.minimum &&
//                       !job?.salary?.maximum &&
//                       !job?.salary?.exactAmount
//                         ? "₹ Not Disclosed"
//                         : formattedSalary
//                     }
//                     experience={`${
//                       job?.requiredExperience?.minimum < 1
//                         ? " Freshers  / ("
//                         : ""
//                     }  ${job?.requiredExperience?.minimum} - ${
//                       job?.requiredExperience?.maximum
//                     } ${job?.requiredExperience?.minimum < 1 ? ") " : ""} yrs`}
//                     location={job?.jobLocation || "Location"}
//                     jobType={job?.jobMode || "Job Type"}
//                     onApply={() => {
//                       // scrollRef.current.scrollIntoView({ behavior: 'smooth' });
//                       if (scrollRef.current) {
//                         scrollRef.current.scrollIntoView({
//                           behavior: "smooth",
//                         });
//                       }

//                       handleApply(job?._id);
//                     }}
//                     onApplyMobile={() => handleApplyMobile(job?._id)}
//                     index={index}
//                     hasApplied={applied} // Pass the applied status to the JobCard component
//                   />
//                 );
//               })}

//             </div>
//             </>
//           )}
//           {RecuiterStore.jobpostcount > jobsPerPage && (
//             <div>
//               <ReactPaginate
//                 nextLabel=" >"
//                 className="flex justify-center items-center gap-5 my-4"
//                 onPageChange={handlePageClick}
//                 forcePage={Number(page)}
//                 pageRangeDisplayed={3}
//                 marginPagesDisplayed={2}
//                 pageCount={Math.ceil(RecuiterStore.jobpostcount / jobsPerPage)}
//                 previousLabel="< "
//                 pageClassName="page-item"
//                 pageLinkClassName="page-link"
//                 previousClassName="page-item"
//                 previousLinkClassName="page-link"
//                 nextClassName="page-item"
//                 nextLinkClassName="page-link"
//                 breakLabel="..."
//                 breakClassName="page-item"
//                 breakLinkClassName="page-link"
//                 containerClassName="pagination"
//                 activeClassName="active-page-item"
//                 activeLinkClassName="active-page-link"
//                 renderOnZeroPageCount={null}
//                 // initialPage={RecuiterStore.jobListPage} // Use this to set the initial page
//               />
//             </div>
//           )}
//         </div>
//       </>
//     );
//   });
// };

// export default JobList;import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useStores } from "../../store";
import { useObserver } from "mobx-react";
import ReactPaginate from "react-paginate";
import JobCard from "./JobCard";
import JobInternshipShimmer from "./components/JobInternshipShimmer";
import image from "../../assests/office-building.png";
import { useState, useEffect } from "react";
import { toJS } from "mobx";

const JobList = ({ scrollRef }) => {
  const { RecuiterStore } = useStores();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const jobsPerPage = 12;
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const page = Number(query.get("page")) || 0;

  const fetchJobs = async (currentPage = 0) => {
    try {
      setLoading(true);
      const skip = currentPage * jobsPerPage;
      const body = { skip, limit: jobsPerPage };
      await RecuiterStore.fetchJobPosts(body);

      if (RecuiterStore.jobApplications.length === 0) {
        const bodyForApplications = { skip: 0, limit: jobsPerPage };
        await RecuiterStore.fetchJobApplications(bodyForApplications);
      }
    } catch (err) {
      setError("Failed to fetch job posts. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Watch for page changes in the URL and fetch jobs accordingly
  useEffect(() => {
    fetchJobs(page);
  }, [page]);

  const handleApply = (jobPostId) => {
    const appliedApplication = RecuiterStore.jobApplications.find(
      (application) => application.jobPostId._id === jobPostId
    );
    navigate(
      appliedApplication
        ? `/dashboard/myapplicants/${appliedApplication._id}`
        : `/dashboard/JobInternship/job-post/${jobPostId}`
    );
  };

  const handleApplyMobile = (jobPostId) => {
    const appliedApplication = RecuiterStore.jobApplications.find(
      (application) => application.jobPostId._id === jobPostId
    );
    navigate(
      appliedApplication
        ? `/newone/${appliedApplication._id}`
        : `/jobpost/${jobPostId}`
    );
  };

  const hasApplied = (jobId) => {
    return RecuiterStore.jobApplications.some(
      (application) => application.jobPostId?._id === jobId
    );
  };

  const handlePageClick = (event) => {
    navigate("/dashboard/jobinternship?page=" + event.selected);
  };

  const checkSalary = (salary) => {
    if (salary === undefined || salary === null) return "N/A";
    if (salary >= 10000000) {
      return `${salary / 10000000}Cr`;
    }
    if (salary >= 100000) {
      return `${salary / 100000}L`;
    }
    if (salary >= 1000) {
      return `${salary / 1000}K`;
    }
    return salary;
  };

  return useObserver(() => {
    if (error) return <div>{error}</div>;

    return (
      <div className="md:pb-0 lg:pb-0 pb-[13%]">
        {loading ? (
          <JobInternshipShimmer />
        ) : (
          <>
            {RecuiterStore.jobPosts.length === 0 && (
              <div className="flex items-center ml-5 justify-center w-full h-[60vh]">
                <h1 className="text-primary  text-3xl">
                  Oops! No results found. Broaden your search criteria and try
                  again.
                </h1>
              </div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 md:mr-7">
             {RecuiterStore.jobPosts.map((job, index) => {
                const applied = hasApplied(job?._id);
                const minSalary = checkSalary(job?.salary?.minimum);
                const maxSalary = checkSalary(job?.salary?.maximum);

                const formattedSalary =
                  minSalary !== "N/A" && maxSalary !== "N/A"
                    ? `${
                        job?.salary?.currency?.split(" ")[0] || "₹"
                      } ${minSalary} - ${maxSalary} ${job?.salary?.rate.replace(
                        "per",
                        ""
                      )}`
                    : `${
                        job?.salary?.currency?.split(" ")[0] || "₹"
                      } ${checkSalary(
                        job?.salary?.exactAmount || job?.salary?.minimum
                      )} / ${
                        job?.salary?.rate === "perYear"
                          ? "Year"
                          : job?.salary?.rate === "perMonth"
                          ? "Month"
                          : job?.salary?.rate === "perDay"
                          ? "Day"
                          : job?.salary?.rate === "perHour"
                          ? "Hour"
                          : ""
                      }`;

                return (
                  <JobCard
                    job={job}
                    JobInternship={true}
                    key={job?._id}
                    logo={job?.recruiterId?.pic || image}
                    featured={job?.featured || false}
                    title={job?.jobTitle || "Job Title"}
                    company={job?.recruiterId?.companyName}
                    postedTime={job?.createdAt}
                    // location={job?.jobLocation || "-"}
                    isOpen={job?.isOpen}
                    salaryRange={
                      !job?.salary?.minimum &&
                      !job?.salary?.maximum &&
                      !job?.salary?.exactAmount
                        ? "₹ Not Disclosed"
                        : formattedSalary
                    }
                    skills={toJS(job?.requiredSkills)}
                    experience={`${
                      // job?.requiredExperience?.minimum < 1 ? "Freshers / (" : ""
                      job?.requiredExperience?.minimum < 1 ? "" : ""
                    } ${job?.requiredExperience?.minimum} - ${
                      job?.requiredExperience?.maximum
                      // } ${job?.requiredExperience?.minimum < 1 ? ") " : ""}yrs`}
                    } ${job?.requiredExperience?.minimum < 1 ? "" : ""}`}
                    location={job?.jobLocation || "Location"}
                    jobType={job?.jobMode || "Job Type"}
                    onApply={() => {
                      if (scrollRef.current) {
                        scrollRef.current.scrollIntoView({
                          behavior: "smooth",
                        });
                      }
                      handleApply(job?._id);
                    }}
                    onApplyMobile={() => handleApplyMobile(job?._id)}
                    index={index}
                    hasApplied={applied}
                  />
                );
              })} 
            </div>
          </>
        )}
        {RecuiterStore.jobpostcount > jobsPerPage && (
          <div className="">
            {/* {page > 1 && ( */}
            <ReactPaginate
              nextLabel={page == page.toFixed(0) - 1 ? "" : ">"}
              className="flex justify-center items-center gap-5 py-10 "
              onPageChange={handlePageClick}
              forcePage={page}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={Math.ceil(RecuiterStore.jobpostcount / jobsPerPage)}
              previousLabel={page < 1 ? " " : "<"}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active-page-item"
              activeLinkClassName="active-page-link"
            />
            {/* )} */}
          </div>
        )}
      </div>
    );
  });
};

export default JobList;
